<template>
  <ChartCard
    :title="title"
    wrapper_class="pt-0">
    <template #chart>
      <SpilkaChartsMF
        v-if="growthBook.mf_apex"
        height="250"
        kind="scatter"
        :series="mfSeries"/>
      <ApexChartScatter
        v-else
        :chart-options="chartOptions"
        height="250"
        :series="series"/>
    </template>
  </ChartCard>
</template>

<script>
import ChartCard from 'components/charts/ChartCard.vue'
import ApexChartScatter from 'components/charts/ApexChartScatter.vue'
import SpilkaChartsMF from 'components/common/SpilkaChartsMF.vue'

import ua from 'apexcharts/dist/locales/ua.json'
import en from 'apexcharts/dist/locales/en.json'
import moment from 'moment'

export default {
  name: 'bidHistoryScatterChart',
  data() {
    return {
      currencies: []
    }
  },
  props: {
    title: String,
    items: Array,
    by: String
  },
  async created() {
    await this.$store.dispatch('setCurrencies')
      .then(res => this.currencies = res)
  },
  computed: {
    series() {
      let groups = this.$_.groupBy( this.items.map(item => ({...item, currency: this.currencies?.find(el => el.code == item.currencyId)?.shortTitle }) ) ,  this.by )
      return Object.entries(groups).map(([name, data]) => ({name, data}))
    },
    mfSeries() {
      return this.series.map(({ name, data }) => ({
        name,
        data: data.map(({ x, y, currency }) => ({ x, y, currency })),
      }))
    },
    chartOptions() {
      let lang = sessionStorage.language
      lang = lang == 'uk' ? 'ua' : lang
      return {
        chart: {
          animations: {
            enabled: false,
          },
          locales: [ua, en],
          defaultLocale: lang,
          redrawOnWindowResize: true,
          height: 350,
          type: 'scatter',
          zoom: {
            type: 'xy'
          }
        },
        legend: {
          showForSingleSeries: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: 'right',
          formatter: function(seriesName) {
            return `<span class="h9-text-medium black--text"> ${seriesName}</span>`
          }
        },
        markers: {
        },
        theme: {
          mode: 'light',
          monochrome: {
            enabled: true,
            color: '#b0dbd8',
            shadeTo: 'dark',
            shadeIntensity: 0.4
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: false,
        },
        tooltip: {
          enabled: true,
          onDatasetHover: {
            highlightDataSeries: false,
          },
          marker: {
            show: false,
          },
          x: {
            show: false,
            formatter: (name) => moment(name).format('YYYY.MM.DD HH:mm'),
          },
          y: {
            formatter: (value, {  seriesIndex, dataPointIndex, w }) => {
              return  value + ' ' +  w.config.series[seriesIndex].data[dataPointIndex].currency
            }
          }
        },
        grid: {
          xaxis: {
            lines: {
              show: true
            },
          },
          yaxis: {
            lines: {
              show: true
            }
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false,
          }

        },
      }

    }
  },
  components: {
    ChartCard,
    ApexChartScatter,
    SpilkaChartsMF
  }
}
</script>
